import * as types from './constants';

export const initialState = {
  listData: {
    transactions: [],
    subtotal: null,
    loading: false,
    count: 0,
    next: null,
    previous: null,
    curr_page: 1,
    errors_api: {},
    message: null
  }
};

const actions = {

  // Get Billing Transactions
  [types.GET_BILLING_TRANSACTIONS_REQUEST]: state => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: true
      }
    };

    return { ...data };
  },

  [types.GET_BILLING_TRANSACTIONS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: false,
        transactions: payload.results,
        subtotal: payload.subtotal,
        message: payload.message,
        count: payload.count,
        next: payload.next,
        previous: payload.next
      }
    };

    return { ...data };
  },

  [types.GET_BILLING_TRANSACTIONS_FAILED]: state => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: false
      }
    };

    return { ...data };
  },

  [types.GET_BILLING_TRANSACTIONS_RESET]: () => {
    return { ...initialState };
  },

  [types.BILLING_TRANSACTIONS_SET_PAGE]: (state, { payload }) => {

    const data = {
      ...state,
      listData: {
        ...state.listData,
        curr_page: parseInt(payload) || 1
      }
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

